<template>
  <UpcomingRegisteredEvents
    :registrations="registrations"
    :horse-id="horseId"
    :loading="$apollo.queries.registrations.loading"
    @refetch="$apollo.queries.registrations.refetch()"
  />
</template>

<script>
import { provide, computed } from "vue";
import gql from "fraql";
import UpcomingRegisteredEvents from "@/components/table_templates/UpcomingRegisteredEvents/index.vue";
import dayjs from "dayjs";
import { provideEntryFeiRegistrationQuery } from "@elements/AppEntryFeiActions/compositions";

const registrationQuery = gql`
  query horseUpcomingRegistrations(
    $horseId: ID, 
    $eventStartDateFrom: String
  ) {
    registrations(
      horseId: $horseId
      eventStartDateFrom: $eventStartDateFrom
    ) {
    ${UpcomingRegisteredEvents.fragments.registrations}
  }
}
`;

export default {
  name: "HorseUpcomingEvents",
  components: {
    UpcomingRegisteredEvents
  },
  props: {
    horseId: {
      type: String,
      required: true
    }
  },
  emits: ["hasRegs"],
  setup(props) {
    const variables = computed(() => {
      return {
        horseId: props.horseId,
        eventStartDateFrom: dayjs().format("YYYY-MM-DD")
      };
    });

    provide("RegistrationsRefetchQueryName", "horseUpcomingRegistrations");

    provideEntryFeiRegistrationQuery(
      () => registrationQuery,
      () => variables
    );

    return {
      variables
    };
  },
  data() {
    return {
      registrations: []
    };
  },
  apollo: {
    registrations: {
      query: registrationQuery,
      variables() {
        return this.variables;
      },
      fetchPolicy: "cache-and-network"
    }
  }
};
</script>
